// Versione del frontend in esercizio: commit e ora della build, iniettati da
// Cloud Build (cloudbuild-frontend.yaml → Dockerfile → REACT_APP_BUILD_*).
// In locale le variabili non ci sono e si mostra "sviluppo".

export interface VersioneApp {
  /** Commit breve (es. "25ee152") o "sviluppo" in locale */
  versione: string;
  /** Data e ora della build nel fuso di Roma (es. "23/09/2026 14:32"), null in locale */
  rilascio: string | null;
  /** Testo completo per il tooltip */
  dettaglio: string;
}

export function formattaRilascio(iso: string | undefined): string | null {
  if (!iso) return null;
  const d = new Date(iso);
  if (isNaN(d.getTime())) return null;
  const parti = new Intl.DateTimeFormat('it-IT', {
    timeZone: 'Europe/Rome',
    day: '2-digit', month: '2-digit', year: 'numeric',
    hour: '2-digit', minute: '2-digit', hour12: false,
  }).formatToParts(d);
  const p = (t: string) => parti.find(x => x.type === t)?.value ?? '';
  return `${p('day')}/${p('month')}/${p('year')} ${p('hour')}:${p('minute')}`;
}

export function leggiVersione(env: Record<string, string | undefined> = process.env): VersioneApp {
  const commit = (env.REACT_APP_BUILD_COMMIT || '').trim();
  const versione = commit ? commit.slice(0, 7) : 'sviluppo';
  const rilascio = formattaRilascio(env.REACT_APP_BUILD_TIME);
  const dettaglio = commit
    ? `Versione ${commit}${rilascio ? ` · rilasciata il ${rilascio}` : ''}`
    : 'Versione di sviluppo locale';
  return { versione, rilascio, dettaglio };
}
